import ValuePerTurnCalculator from "../crew/ValuePerTurnCalculator";
import BigNum from "../math/BigNum";
import BigNumSave from "./BigNumSave";

export default class ValuePerTurnSave {
    constructor() {        
    }

    /**
     * @param {ValuePerTurnCalculator} calculator
     * @returns {Object}
     */
    static generateSave(calculator) {
        const saveState = {};

        saveState.sum = BigNumSave.save(calculator.sum);
        saveState.startTurn = calculator.startTurn;
        saveState.valuePerTurn = BigNumSave.save(calculator.valuePerTurn);
        saveState.rateIndex = calculator.rateIndex;

        saveState.rates = [];
        for (let i = 0; i < calculator.rates.length; i++) {
            saveState.rates.push(BigNumSave.save(calculator.rates[i]));
        }

        return saveState;
    }

    /**
     * @param {ValuePerTurnCalculator} calculator
     * @param {Object} saveState 
     */
    static loadSave(calculator, saveState) {
        if (!saveState) {
            return;
        }

        BigNumSave.load(saveState.sum, calculator.sum);

        if (saveState.startTurn) {
            calculator.startTurn = saveState.startTurn;
        }

        BigNumSave.load(saveState.valuePerTurn, calculator.valuePerTurn);

        calculator.rateIndex = 0;
        if (saveState.rateIndex) {
            calculator.rateIndex = saveState.rateIndex;
        }

        if (saveState.rates) {
            // Make sure the rates are cleared out.
            calculator.rates.length = 0;

            for (let i = 0; i < saveState.rates.length; i++) {
                const rate = new BigNum(0);
                BigNumSave.load(saveState.rates[i], rate);
                calculator.rates.push(rate);
            }
        }
    }

}